export type { ColorSchemeType } from './types';

export const DEFAULT_COLOR_SCHEME = 'light';

export const ColorScheme = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;
